import { AffordableVideoEditingServicesInAlBarsha } from "../../../Pages/AllSeoPages/VideoAdProduction/al_barsha/AffordableVideoEditingServicesInAlBarsha";
import { AnimatedVideoProductionInAlBarsha } from "../../../Pages/AllSeoPages/VideoAdProduction/al_barsha/AnimatedVideoProductionInAlBarsha";
import { BestVideoProductionServicesInAlBarsha } from "../../../Pages/AllSeoPages/VideoAdProduction/al_barsha/BestVideoProductionServicesInAlBarsha";
import { BusinessVideoProductionInAlBarsha } from "../../../Pages/AllSeoPages/VideoAdProduction/al_barsha/BusinessVideoProductionInAlBarsha";
import { CommercialAdVideoProductionInAlBarsha } from "../../../Pages/AllSeoPages/VideoAdProduction/al_barsha/CommercialAdVideoProductionInAlBarsha";
import { CorporateVideoProductionInAlBarsha } from "../../../Pages/AllSeoPages/VideoAdProduction/al_barsha/CorporateVideoProductionInAlBarsha";
import { CreativeVideoProductionCompanyInAlBarsha } from "../../../Pages/AllSeoPages/VideoAdProduction/al_barsha/CreativeVideoProductionCompanyInAlBarsha";
import { DigitalMarketingVideosInAlBarsha } from "../../../Pages/AllSeoPages/VideoAdProduction/al_barsha/DigitalMarketingVideosInAlBarsha";
import { DocumentaryVideoServicesInAlBarsha } from "../../../Pages/AllSeoPages/VideoAdProduction/al_barsha/DocumentaryVideoServicesInAlBarsha";
import { ELearningTrainingVideoProductionInAlBarsha } from "../../../Pages/AllSeoPages/VideoAdProduction/al_barsha/ELearningTrainingVideoProductionInAlBarsha";
import { EventVideoRecordingInAlBarsha } from "../../../Pages/AllSeoPages/VideoAdProduction/al_barsha/EventVideoRecordingInAlBarsha";
import { GreenScreenVideoProductionInAlBarsha } from "../../../Pages/AllSeoPages/VideoAdProduction/al_barsha/GreenScreenVideoProductionInAlBarsha";
import { HighQualityVideoFilmingInAlBarsha } from "../../../Pages/AllSeoPages/VideoAdProduction/al_barsha/HighQualityVideoFilmingInAlBarsha";
import { ProductVideoMarketingInAlBarsha } from "../../../Pages/AllSeoPages/VideoAdProduction/al_barsha/ProductVideoMarketingInAlBarsha";
import { ProfessionalVideographersInAlBarsha } from "../../../Pages/AllSeoPages/VideoAdProduction/al_barsha/ProfessionalVideographersInAlBarsha";
import { PromotionalVideoServicesInAlBarsha } from "../../../Pages/AllSeoPages/VideoAdProduction/al_barsha/PromotionalVideoServicesInAlBarsha";
import { RealEstateVideographyInAlBarsha } from "../../../Pages/AllSeoPages/VideoAdProduction/al_barsha/RealEstateVideographyInAlBarsha";
import { ShortFilmProductionServicesInAlBarsha } from "../../../Pages/AllSeoPages/VideoAdProduction/al_barsha/ShortFilmProductionServicesInAlBarsha";
import { SocialMediaContentCreationInAlBarsha } from "../../../Pages/AllSeoPages/VideoAdProduction/al_barsha/SocialMediaContentCreationInAlBarsha";
import { YouTubeVideoProductionInAlBarsha } from "../../../Pages/AllSeoPages/VideoAdProduction/al_barsha/YouTubeVideoProductionInAlBarsha";
import { Helmet } from "react-helmet";

export const BestVideoProductionServicesInAlBarshaSEO = () => (
  <>
    <Helmet>
      {/* Page Title */}
      <title>Best Video Production Services in Al Barsha | MilaajBrandset</title>

      {/* Meta Description */}
      <meta
        name="description"
        content="MilaajBrandset provides the best video production services in Al Barsha, creating high-quality, engaging videos that elevate your brand and captivate audiences."
      />

      {/* Meta Keywords */}
      <meta
        name="keywords"
        content="best video production services Al Barsha, video production Al Barsha, professional video services, high-quality video production Al Barsha"
      />

      {/* Open Graph (OG) Tags for Social Media Sharing */}
      <meta
        property="og:title"
        content="Best Video Production Services in Al Barsha | MilaajBrandset"
      />
      <meta
        property="og:description"
        content="MilaajBrandset provides the best video production services in Al Barsha, creating high-quality, engaging videos that elevate your brand and captivate audiences."
      />
      <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
      <meta
        property="og:url"
        content="https://milaajbrandset.com/best-video-production-services-in-al-barsha"
      />
      <meta property="og:type" content="website" />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Best Video Production Services in Al Barsha | MilaajBrandset"
      />
      <meta
        name="twitter:description"
        content="MilaajBrandset provides the best video production services in Al Barsha, creating high-quality, engaging videos that elevate your brand and captivate audiences."
      />
      <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />

      {/* Schema Markup for Local SEO */}
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            "name": "MilaajBrandset",
            "image": "https://milaajbrandset.com/favicon.ico",
            "description": "MilaajBrandset provides the best video production services in Al Barsha, creating high-quality, engaging videos that elevate your brand and captivate audiences.",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Al Barsha, Dubai",
              "addressCountry": "AE"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 25.1120, // Approximate latitude for Al Barsha
              "longitude": 55.1929 // Approximate longitude for Al Barsha
            },
          
            "url": "https://milaajbrandset.com/best-video-production-services-in-al-barsha"
          }
        `}
      </script>
    </Helmet>
    <BestVideoProductionServicesInAlBarsha/>
  </>
);



export const ProfessionalVideographersInAlBarshaSEO = () => (
  <>
    <Helmet>
      {/* Page Title */}
      <title>Professional Videographers in Al Barsha | MilaajBrandset</title>

      {/* Meta Description */}
      <meta
        name="description"
        content="MilaajBrandset offers professional videography services in Al Barsha, delivering cinematic, high-impact videos for corporate events, promotions, and more to elevate your brand."
      />

      {/* Meta Keywords */}
      <meta
        name="keywords"
        content="professional videographers Al Barsha, videography services Al Barsha, cinematic video production, corporate videography Al Barsha"
      />

      {/* Open Graph (OG) Tags for Social Media Sharing */}
      <meta
        property="og:title"
        content="Professional Videographers in Al Barsha | MilaajBrandset"
      />
      <meta
        property="og:description"
        content="MilaajBrandset offers professional videography services in Al Barsha, delivering cinematic, high-impact videos for corporate events, promotions, and more to elevate your brand."
      />
      <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
      <meta
        property="og:url"
        content="https://milaajbrandset.com/professional-videographers-in-al-barsha"
      />
      <meta property="og:type" content="website" />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Professional Videographers in Al Barsha | MilaajBrandset"
      />
      <meta
        name="twitter:description"
        content="MilaajBrandset offers professional videography services in Al Barsha, delivering cinematic, high-impact videos for corporate events, promotions, and more to elevate your brand."
      />
      <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />

      {/* Schema Markup for Local SEO */}
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            "name": "MilaajBrandset",
            "image": "https://milaajbrandset.com/favicon.ico",
            "description": "MilaajBrandset offers professional videography services in Al Barsha, delivering cinematic, high-impact videos for corporate events, promotions, and more to elevate your brand.",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Al Barsha, Dubai",
              "addressCountry": "AE"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 25.1120,
              "longitude": 55.1929
            },
           
            "url": "https://milaajbrandset.com/professional-videographers-in-al-barsha"
          }
        `}
      </script>
    </Helmet>
    <ProfessionalVideographersInAlBarsha />
  </>
);



export const CorporateVideoProductionInAlBarshaSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Corporate Video Production in Al Barsha | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset provides professional corporate video production in Al Barsha, creating polished, high-impact videos for promos, training, and branding to elevate your business."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="corporate video production Al Barsha, professional corporate videography, corporate video services Al Barsha, business video production"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Corporate Video Production in Al Barsha | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset provides professional corporate video production in Al Barsha, creating polished, high-impact videos for promos, training, and branding to elevate your business."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/corporate-video-production-in-al-barsha"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Corporate Video Production in Al Barsha | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset provides professional corporate video production in Al Barsha, creating polished, high-impact videos for promos, training, and branding to elevate your business."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset provides professional corporate video production in Al Barsha, creating polished, high-impact videos for promos, training, and branding to elevate your business.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Al Barsha, Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.1120,
                "longitude": 55.1929
              },
             
              "url": "https://milaajbrandset.com/corporate-video-production-in-al-barsha"
            }
          `}
        </script>
      </Helmet>
      <CorporateVideoProductionInAlBarsha />
    </>
  );



  export const PromotionalVideoServicesInAlBarshaSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Promotional Video Services in Al Barsha | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers professional promotional video services in Al Barsha, creating dynamic, high-impact videos for marketing campaigns and product launches to boost your brand."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="promotional video services Al Barsha, professional promo videos, marketing video production Al Barsha, product launch videos"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Promotional Video Services in Al Barsha | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers professional promotional video services in Al Barsha, creating dynamic, high-impact videos for marketing campaigns and product launches to boost your brand."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/promotional-video-services-in-al-barsha"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Promotional Video Services in Al Barsha | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers professional promotional video services in Al Barsha, creating dynamic, high-impact videos for marketing campaigns and product launches to boost your brand."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers professional promotional video services in Al Barsha, creating dynamic, high-impact videos for marketing campaigns and product launches to boost your brand.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Al Barsha, Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.1120,
                "longitude": 55.1929
              },
              
              "url": "https://milaajbrandset.com/promotional-video-services-in-al-barsha"
            }
          `}
        </script>
      </Helmet>
      <PromotionalVideoServicesInAlBarsha />
    </>
  );



  
export const BusinessVideoProductionInAlBarshaSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Business Video Production in Al Barsha | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers professional business video production in Al Barsha, creating high-impact videos for promos, product showcases, and branding to drive growth."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="business video production Al Barsha, professional business videography, corporate video services Al Barsha, brand video production"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Business Video Production in Al Barsha | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers professional business video production in Al Barsha, creating high-impact videos for promos, product showcases, and branding to drive growth."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/business-video-production-in-al-barsha"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Business Video Production in Al Barsha | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers professional business video production in Al Barsha, creating high-impact videos for promos, product showcases, and branding to drive growth."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers professional business video production in Al Barsha, creating high-impact videos for promos, product showcases, and branding to drive growth.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Al Barsha, Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.1120,
                "longitude": 55.1929
              },
              
              "url": "https://milaajbrandset.com/business-video-production-in-al-barsha"
            }
          `}
        </script>
      </Helmet>
      <BusinessVideoProductionInAlBarsha />
    </>
  );



  export const AffordableVideoEditingServicesInAlBarshaSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Affordable Video Editing Services in Al Barsha | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset provides affordable video editing services in Al Barsha, delivering professional, high-impact videos for social media, promos, and more on a budget."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="affordable video editing Al Barsha, professional video editing services, budget video production Al Barsha, social media video editing"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Affordable Video Editing Services in Al Barsha | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset provides affordable video editing services in Al Barsha, delivering professional, high-impact videos for social media, promos, and more on a budget."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/affordable-video-editing-services-in-al-barsha"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Affordable Video Editing Services in Al Barsha | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset provides affordable video editing services in Al Barsha, delivering professional, high-impact videos for social media, promos, and more on a budget."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset provides affordable video editing services in Al Barsha, delivering professional, high-impact videos for social media, promos, and more on a budget.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Al Barsha, Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.1120,
                "longitude": 55.1929
              },
             
              "url": "https://milaajbrandset.com/affordable-video-editing-services-in-al-barsha"
            }
          `}
        </script>
      </Helmet>
      <AffordableVideoEditingServicesInAlBarsha />
    </>
  );



  export const SocialMediaContentCreationInAlBarshaSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Social Media Content Creation in Al Barsha | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers professional social media content creation in Al Barsha, delivering engaging videos, graphics, and posts for Instagram, LinkedIn, TikTok, and more to boost your brand."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="social media content creation Al Barsha, professional social media videos, social media marketing Al Barsha, Instagram content creation"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Social Media Content Creation in Al Barsha | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers professional social media content creation in Al Barsha, delivering engaging videos, graphics, and posts for Instagram, LinkedIn, TikTok, and more to boost your brand."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/social-media-content-creation-in-al-barsha"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Social Media Content Creation in Al Barsha | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers professional social media content creation in Al Barsha, delivering engaging videos, graphics, and posts for Instagram, LinkedIn, TikTok, and more to boost your brand."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers professional social media content creation in Al Barsha, delivering engaging videos, graphics, and posts for Instagram, LinkedIn, TikTok, and more to boost your brand.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Al Barsha, Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.1120,
                "longitude": 55.1929
              },
             
              "url": "https://milaajbrandset.com/social-media-content-creation-in-al-barsha"
            }
          `}
        </script>
      </Helmet>
      <SocialMediaContentCreationInAlBarsha />
    </>
  );



  export const CreativeVideoProductionCompanyInAlBarshaSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Creative Video Production Company in Al Barsha | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset is a leading creative video production company in Al Barsha, delivering cinematic, narrative-driven videos for brands, social media, and campaigns."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="creative video production Al Barsha, cinematic video production, video production company Al Barsha, storytelling videos"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Creative Video Production Company in Al Barsha | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset is a leading creative video production company in Al Barsha, delivering cinematic, narrative-driven videos for brands, social media, and campaigns."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/creative-video-production-company-in-al-barsha"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Creative Video Production Company in Al Barsha | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset is a leading creative video production company in Al Barsha, delivering cinematic, narrative-driven videos for brands, social media, and campaigns."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset is a leading creative video production company in Al Barsha, delivering cinematic, narrative-driven videos for brands, social media, and campaigns.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Al Barsha, Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.1120,
                "longitude": 55.1929
              },
              
              "url": "https://milaajbrandset.com/creative-video-production-company-in-al-barsha"
            }
          `}
        </script>
      </Helmet>
      <CreativeVideoProductionCompanyInAlBarsha />
    </>
  );




  export const YouTubeVideoProductionInAlBarshaSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>YouTube Video Production in Al Barsha | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers professional YouTube video production in Al Barsha, creating engaging, high-quality videos for vlogs, tutorials, and more to grow your channel."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="YouTube video production Al Barsha, professional YouTube content, video production for YouTube, Al Barsha video services"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="YouTube Video Production in Al Barsha | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers professional YouTube video production in Al Barsha, creating engaging, high-quality videos for vlogs, tutorials, and more to grow your channel."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/youtube-video-production-in-al-barsha"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="YouTube Video Production in Al Barsha | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers professional YouTube video production in Al Barsha, creating engaging, high-quality videos for vlogs, tutorials, and more to grow your channel."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers professional YouTube video production in Al Barsha, creating engaging, high-quality videos for vlogs, tutorials, and more to grow your channel.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Al Barsha, Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.1120,
                "longitude": 55.1929
              },
              
              "url": "https://milaajbrandset.com/youtube-video-production-in-al-barsha"
            }
          `}
        </script>
      </Helmet>
      <YouTubeVideoProductionInAlBarsha />
    </>
  );



  export const EventVideoRecordingInAlBarshaSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Event Video Recording in Al Barsha | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers professional event video recording in Al Barsha, capturing weddings, corporate events, and more with cinematic quality to preserve your moments."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="event video recording Al Barsha, professional event videography, wedding video production Al Barsha, corporate event videos"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Event Video Recording in Al Barsha | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers professional event video recording in Al Barsha, capturing weddings, corporate events, and more with cinematic quality to preserve your moments."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/event-video-recording-in-al-barsha"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Event Video Recording in Al Barsha | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers professional event video recording in Al Barsha, capturing weddings, corporate events, and more with cinematic quality to preserve your moments."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers professional event video recording in Al Barsha, capturing weddings, corporate events, and more with cinematic quality to preserve your moments.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Al Barsha, Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.1120,
                "longitude": 55.1929
              },
             
              "url": "https://milaajbrandset.com/event-video-recording-in-al-barsha"
            }
          `}
        </script>
      </Helmet>
      <EventVideoRecordingInAlBarsha />
    </>
  );



  export const HighQualityVideoFilmingInAlBarshaSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>High-Quality Video Filming in Al Barsha | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers professional high-quality video filming in Al Barsha, delivering cinematic footage for events, brands, and campaigns with state-of-the-art equipment."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="high-quality video filming Al Barsha, professional video production, cinematic video services Al Barsha, event videography"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="High-Quality Video Filming in Al Barsha | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers professional high-quality video filming in Al Barsha, delivering cinematic footage for events, brands, and campaigns with state-of-the-art equipment."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/high-quality-video-filming-in-al-barsha"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="High-Quality Video Filming in Al Barsha | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers professional high-quality video filming in Al Barsha, delivering cinematic footage for events, brands, and campaigns with state-of-the-art equipment."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers professional high-quality video filming in Al Barsha, delivering cinematic footage for events, brands, and campaigns with state-of-the-art equipment.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Al Barsha, Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.1120,
                "longitude": 55.1929
              },
              
              "url": "https://milaajbrandset.com/high-quality-video-filming-in-al-barsha"
            }
          `}
        </script>
      </Helmet>
      <HighQualityVideoFilmingInAlBarsha />
    </>
  );






  export const ShortFilmProductionServicesInAlBarshaSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Short Film Production Services in Al Barsha | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers professional short film production services in Al Barsha, creating cinematic, narrative-driven films for festivals, branding, or personal projects."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="short film production Al Barsha, cinematic film production, narrative-driven short films, Al Barsha video services"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Short Film Production Services in Al Barsha | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers professional short film production services in Al Barsha, creating cinematic, narrative-driven films for festivals, branding, or personal projects."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/short-film-production-services-in-al-barsha"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Short Film Production Services in Al Barsha | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers professional short film production services in Al Barsha, creating cinematic, narrative-driven films for festivals, branding, or personal projects."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers professional short film production services in Al Barsha, creating cinematic, narrative-driven films for festivals, branding, or personal projects.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Al Barsha, Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.1120,
                "longitude": 55.1929
              },
             
              "url": "https://milaajbrandset.com/short-film-production-services-in-al-barsha"
            }
          `}
        </script>
      </Helmet>
      <ShortFilmProductionServicesInAlBarsha />
    </>
  );



  export const AnimatedVideoProductionInAlBarshaSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Animated Video Production in Al Barsha | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers professional animated video production in Al Barsha, creating engaging 2D, 3D, and stop motion videos for brands, education, and entertainment."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="animated video production Al Barsha, 2D animation services, stop motion videos, Al Barsha animation studio"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Animated Video Production in Al Barsha | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers professional animated video production in Al Barsha, creating engaging 2D, 3D, and stop motion videos for brands, education, and entertainment."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/animated-video-production-in-al-barsha"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Animated Video Production in Al Barsha | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers professional animated video production in Al Barsha, creating engaging 2D, 3D, and stop motion videos for brands, education, and entertainment."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers professional animated video production in Al Barsha, creating engaging 2D, 3D, and stop motion videos for brands, education, and entertainment.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Al Barsha, Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.1120,
                "longitude": 55.1929
              },
            
              "url": "https://milaajbrandset.com/animated-video-production-in-al-barsha"
            }
          `}
        </script>
      </Helmet>
      <AnimatedVideoProductionInAlBarsha />
    </>
  );



  export const CommercialAdVideoProductionInAlBarshaSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Commercial Ad Video Production in Al Barsha | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers professional commercial ad video production in Al Barsha, creating high-impact, cinematic ads for TV, social media, and campaigns to elevate your brand."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="commercial ad video production Al Barsha, professional video ads, cinematic commercials Al Barsha, social media ad production"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Commercial Ad Video Production in Al Barsha | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers professional commercial ad video production in Al Barsha, creating high-impact, cinematic ads for TV, social media, and campaigns to elevate your brand."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/commercial-ad-video-production-in-al-barsha"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Commercial Ad Video Production in Al Barsha | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers professional commercial ad video production in Al Barsha, creating high-impact, cinematic ads for TV, social media, and campaigns to elevate your brand."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers professional commercial ad video production in Al Barsha, creating high-impact, cinematic ads for TV, social media, and campaigns to elevate your brand.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Al Barsha, Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.1120,
                "longitude": 55.1929
              },
             
              "url": "https://milaajbrandset.com/commercial-ad-video-production-in-al-barsha"
            }
          `}
        </script>
      </Helmet>
      <CommercialAdVideoProductionInAlBarsha />
    </>
  );



  export const DocumentaryVideoServicesInAlBarshaSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Documentary Video Services in Al Barsha | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers professional documentary video services in Al Barsha, creating cinematic, narrative-driven films for personal stories, corporate histories, and more."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="documentary video services Al Barsha, cinematic documentary production, narrative-driven films, Al Barsha video production"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Documentary Video Services in Al Barsha | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers professional documentary video services in Al Barsha, creating cinematic, narrative-driven films for personal stories, corporate histories, and more."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/documentary-video-services-in-al-barsha"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Documentary Video Services in Al Barsha | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers professional documentary video services in Al Barsha, creating cinematic, narrative-driven films for personal stories, corporate histories, and more."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers professional documentary video services in Al Barsha, creating cinematic, narrative-driven films for personal stories, corporate histories, and more.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Al Barsha, Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.1120,
                "longitude": 55.1929
              },
              
              "url": "https://milaajbrandset.com/documentary-video-services-in-al-barsha"
            }
          `}
        </script>
      </Helmet>
      <DocumentaryVideoServicesInAlBarsha />
    </>
  );




  export const ELearningTrainingVideoProductionInAlBarshaSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>E-learning & Training Video Production in Al Barsha | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers professional e-learning and training video production in Al Barsha, creating engaging, high-quality videos for corporate training and online courses."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="e-learning video production Al Barsha, training video services, educational video production, Al Barsha video production"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="E-learning & Training Video Production in Al Barsha | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers professional e-learning and training video production in Al Barsha, creating engaging, high-quality videos for corporate training and online courses."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/e-learning-training-video-production-in-al-barsha"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="E-learning & Training Video Production in Al Barsha | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers professional e-learning and training video production in Al Barsha, creating engaging, high-quality videos for corporate training and online courses."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers professional e-learning and training video production in Al Barsha, creating engaging, high-quality videos for corporate training and online courses.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Al Barsha, Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.1120,
                "longitude": 55.1929
              },
            
              "url": "https://milaajbrandset.com/e-learning-training-video-production-in-al-barsha"
            }
          `}
        </script>
      </Helmet>
      <ELearningTrainingVideoProductionInAlBarsha />
    </>
  );



  export const ProductVideoMarketingInAlBarshaSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Product Video Marketing in Al Barsha | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers professional product video marketing in Al Barsha, creating engaging, high-quality videos for e-commerce, social media, and campaigns to drive sales."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="product video marketing Al Barsha, e-commerce product videos, social media promo videos, Al Barsha video production"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Product Video Marketing in Al Barsha | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers professional product video marketing in Al Barsha, creating engaging, high-quality videos for e-commerce, social media, and campaigns to drive sales."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/product-video-marketing-in-al-barsha"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Product Video Marketing in Al Barsha | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers professional product video marketing in Al Barsha, creating engaging, high-quality videos for e-commerce, social media, and campaigns to drive sales."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers professional product video marketing in Al Barsha, creating engaging, high-quality videos for e-commerce, social media, and campaigns to drive sales.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Al Barsha, Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.1120,
                "longitude": 55.1929
              },
             
              "url": "https://milaajbrandset.com/product-video-marketing-in-al-barsha"
            }
          `}
        </script>
      </Helmet>
      <ProductVideoMarketingInAlBarsha />
    </>
  );



  export const GreenScreenVideoProductionInAlBarshaSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Green Screen Video Production in Al Barsha | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers professional green screen video production in Al Barsha, creating dynamic, immersive videos for commercials, virtual events, and more."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="green screen video production Al Barsha, chroma key video services, immersive video production, Al Barsha video production"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Green Screen Video Production in Al Barsha | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers professional green screen video production in Al Barsha, creating dynamic, immersive videos for commercials, virtual events, and more."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/green-screen-video-production-in-al-barsha"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Green Screen Video Production in Al Barsha | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers professional green screen video production in Al Barsha, creating dynamic, immersive videos for commercials, virtual events, and more."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers professional green screen video production in Al Barsha, creating dynamic, immersive videos for commercials, virtual events, and more.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Al Barsha, Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.1120,
                "longitude": 55.1929
              },
             
              "url": "https://milaajbrandset.com/green-screen-video-production-in-al-barsha"
            }
          `}
        </script>
      </Helmet>
      <GreenScreenVideoProductionInAlBarsha />
    </>
  );



export const DigitalMarketingVideosInAlBarshaSEO = () => (
  <>
    <Helmet>
      {/* Page Title */}
      <title>Digital Marketing Videos in Al Barsha | MilaajBrandset</title>

      {/* Meta Description */}
      <meta
        name="description"
        content="MilaajBrandset offers professional digital marketing videos in Al Barsha, creating engaging, high-quality videos that boost your brand’s online presence and drive engagement."
      />

      {/* Meta Keywords */}
      <meta
        name="keywords"
        content="digital marketing videos Al Barsha, professional video marketing Al Barsha, high-quality marketing videos, video production Al Barsha"
      />

      {/* Open Graph (OG) Tags for Social Media Sharing */}
      <meta
        property="og:title"
        content="Digital Marketing Videos in Al Barsha | MilaajBrandset"
      />
      <meta
        property="og:description"
        content="MilaajBrandset offers professional digital marketing videos in Al Barsha, creating engaging, high-quality videos that boost your brand’s online presence and drive engagement."
      />
      <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
      <meta
        property="og:url"
        content="https://milaajbrandset.com/digital-marketing-videos-in-al-barsha"
      />
      <meta property="og:type" content="website" />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Digital Marketing Videos in Al Barsha | MilaajBrandset"
      />
      <meta
        name="twitter:description"
        content="MilaajBrandset offers professional digital marketing videos in Al Barsha, creating engaging, high-quality videos that boost your brand’s online presence and drive engagement."
      />
      <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />

      {/* Schema Markup for Local SEO */}
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            "name": "MilaajBrandset",
            "image": "https://milaajbrandset.com/favicon.ico",
            "description": "MilaajBrandset offers professional digital marketing videos in Al Barsha, creating engaging, high-quality videos that boost your brand’s online presence and drive engagement.",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Al Barsha, Dubai",
              "addressCountry": "AE"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 25.1000, // Approximate latitude for Al Barsha
              "longitude": 55.1787 // Approximate longitude for Al Barsha
            },
            
            "url": " HTTPS://milaajbrandset.com/digital-marketing-videos-in-al-barsha"
          }
        `}
      </script>
    </Helmet>
    <DigitalMarketingVideosInAlBarsha />
  </>
);



export const RealEstateVideographyInAlBarshaSEO = () => (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Real Estate Videography in Al Barsha | MilaajBrandset</title>
  
        {/* Meta Description */}
        <meta
          name="description"
          content="MilaajBrandset offers professional real estate videography in Al Barsha, creating stunning, high-quality videos to showcase your properties and attract buyers."
        />
  
        {/* Meta Keywords */}
        <meta
          name="keywords"
          content="real estate videography Al Barsha, professional property videos Al Barsha, high-quality real estate videos, real estate video production Al Barsha"
        />
  
        {/* Open Graph (OG) Tags for Social Media Sharing */}
        <meta
          property="og:title"
          content="Real Estate Videography in Al Barsha | MilaajBrandset"
        />
        <meta
          property="og:description"
          content="MilaajBrandset offers professional real estate videography in Al Barsha, creating stunning, high-quality videos to showcase your properties and attract buyers."
        />
        <meta property="og:image" content="https://milaajbrandset.com/favicon.ico" />
        <meta
          property="og:url"
          content="https://milaajbrandset.com/real-estate-videography-in-al-barsha"
        />
        <meta property="og:type" content="website" />
  
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Real Estate Videography in Al Barsha | MilaajBrandset"
        />
        <meta
          name="twitter:description"
          content="MilaajBrandset offers professional real estate videography in Al Barsha, creating stunning, high-quality videos to showcase your properties and attract buyers."
        />
        <meta name="twitter:image" content="https://milaajbrandset.com/favicon.ico" />
  
        {/* Schema Markup for Local SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "MilaajBrandset offers professional real estate videography in Al Barsha, creating stunning, high-quality videos to showcase your properties and attract buyers.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Al Barsha, Dubai",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.1000,
                "longitude": 55.1787
              },
             
              "url": "https://milaajbrandset.com/real-estate-videography-in-al-barsha"
            }
          `}
        </script>
      </Helmet>
      <RealEstateVideographyInAlBarsha/>
    </>
  );